export const SET_PARTICIPATING_STARTUPS = 'SET_PARTICIPATING_STARTUPS';
export const SET_INACTIVE_STARTUPS = 'SET_INACTIVE_STARTUPS';

export const GET_STARTUP_DETAIL = {
  REQUEST: 'GET_STARTUP_DETAIL_REQUEST',
  SUCCESS: 'GET_STARTUP_DETAIL_SUCCESS',
  FAILURE: 'GET_STARTUP_DETAIL_FAILURE',
};
